const cardWelcomeTipsId = 'CardType-WelcomeTips';
const cardTopLocationsId = 'CardType-TopLocations';
const cardAssetPerformanceId = 'CardType-AssetPerformance';
const cardPerformanceId = 'CardType-Performance';
const cardDiagnosticId = 'CardType-Diagnostic';
const cardRecommendationsId = 'CardType-Recommendations';
const cardTopCampaignsId = 'CardType-TopCampaigns';
const cardTopAccountsId = 'CardType-TopAccounts';
const cardTopKeywordsId = 'CardType-TopKeyword';
const cardDeviceId = 'CardType-Device';
const cardSearchTermsId = 'CardType-TopSearchTerms';
const cardTopAdGroupsId = 'CardType-TopAdGroup';
const cardCompetitionId = 'CardType-Competition';
const cardConversionTrackingId = 'CardType-Conversion-Tracking';
const cardTopChangesAccountId = 'CardType-TopChanges-Account';
const cardTopChangesCampaignId = 'CardType-TopChanges-Campaign';
const cardTopChangesAdGroupId = 'CardType-TopChanges-AdGroup';
const cardNavigateToFullProductId = 'CardType-NavigateToFullProduct';

export {
  cardWelcomeTipsId,
  cardTopLocationsId,
  cardAssetPerformanceId,
  cardPerformanceId,
  cardDiagnosticId,
  cardRecommendationsId,
  cardTopCampaignsId,
  cardTopAccountsId,
  cardTopKeywordsId,
  cardDeviceId,
  cardSearchTermsId,
  cardTopAdGroupsId,
  cardCompetitionId,
  cardConversionTrackingId,
  cardTopChangesAccountId,
  cardTopChangesCampaignId,
  cardTopChangesAdGroupId,
  cardNavigateToFullProductId,
};
